export default "__VITE_ASSET__Cioym4gx__"